// --24.1015.1840.0000
import * as React from "react";
import axios from 'axios';
// import { useAuth } from "../../services/AuthContext";
// import { SiteURL } from "../Global/constants";

// const { token, currentUser } = useAuth()
interface IpropsGetAllBusinessUnitName{
    setNewBusinessUnit?: React.Dispatch<React.SetStateAction<{}>>
    Refresh?:boolean;
}

let GlobalDataTemp=[]
// let GlobalData={}
// let Data=false
let globalDataTemp: any[] = [];

const fetchertwemp = async (refresh: boolean): Promise<any[]> => {
    // Check if data exists in globalDataTemp and refresh is not requested
    if (globalDataTemp.length && !refresh) {
        return globalDataTemp;
    }

    try {
        const token = localStorage.getItem("CurrentToken");
        const siteUrl = localStorage.getItem("SiteURL");
        // Define the API endpoint
        const apiUrl = `${siteUrl}/_api/web/lists/getbytitle('CLM365General')/items`;
        const params = {
            $select: 'ID,BusinessUnit,CounterpartyType,ObligationCategory,Modified',
            $filter: "Title eq 'GeneralData'"
        };

        // Make the HTTP GET request using axios with token in headers
        const response = await axios.get(apiUrl, {
            headers: {
                Accept: 'application/json;odata=nometadata',
                'odata-version': '',
                Authorization: `Bearer ${token}` // Include the token here
            },
            params
        });

        // Extract data from the response
        const items = response.data?.value || [];
        globalDataTemp = items; // Cache the data
        return items;
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error; // Re-throw error for handling in the calling function
    }
};
export  function GetAllBusinessUnitName({
    setNewBusinessUnit=(_val)=>{},
    Refresh=false
}:IpropsGetAllBusinessUnitName)
{
return fetchertwemp(Refresh).then(c=>{
   const  GlobalData={};
            if (c.length > 0) {
                if (c[0].BusinessUnit != null) {
                    const businessunitArray = JSON.parse(c[0]?.BusinessUnit);
                    businessunitArray.map((curr, index) => {
                        GlobalData[curr.GUID]=curr.Name;
                    })
                  //  return GlobalData
                }
            }
            ////console.log(GlobalData,"GlobalData");
                setNewBusinessUnit({...GlobalData});
                return GlobalData
})
}


export  function GetAllBusinessUnitNameesForGuidData()
{

return fetchertwemp(false).then(c=>{
   const  GlobalData={};
            if (c.length > 0) {
                if (c[0].BusinessUnit != null) {
                    const businessunitArray = JSON.parse(c[0]?.BusinessUnit);
                    businessunitArray.map((curr, index) => {
                        GlobalData[curr.GUID]=curr.Name;
                    })
                  //  return GlobalData
                }
            }
            return GlobalData


})
}
export async function GetAllBusinessUnitOptions({
    setNewBusinessUnit=(_val)=>{},
    Refresh=false
}:IpropsGetAllBusinessUnitName)
{
   
 
return fetchertwemp(Refresh).then(c=>{
 const   GlobalData={};
 const   GlobalData1=[];
            if (c.length > 0) {
                if (c[0].BusinessUnit != null) {
                    const businessunitArray = JSON.parse(c[0]?.BusinessUnit);
                    businessunitArray.map((curr, index) => {
                        let f1={
                            key: curr.GUID, text: curr.Name , code:curr.BusinessCode,label:curr.Name,value:curr.Name
                        }
                        GlobalData1.push(f1) // GlobalData[curr.GUID]=curr.Name;
                    })
                }
            }
           // setNewBusinessUnit(Object.entries(GlobalData)?.map(([key1, column]: any, index) =>    ({ key: key1, text: column })))
           setNewBusinessUnit(GlobalData1) 
        return  GlobalData1//  Object.entries(GlobalData)?.map(([key1, column]: any, index) =>    ({ key: key1, text: column  }))
})
}

export async function GetAllObligationCategoryOptions({
    setNewBusinessUnit=(_val)=>{},
    Refresh=false
}:IpropsGetAllBusinessUnitName)
{
    

return fetchertwemp(Refresh).then(c=>{
   const GlobalData={};
   const ActiveData={};
            if (c.length > 0) {
                if (c[0].ObligationCategory != null) {
                    const ObligationCategoryArray = JSON.parse(c[0]?.ObligationCategory);
                    ObligationCategoryArray.map((curr, index) => {
                        GlobalData[curr.GUID]=curr.Name;
                        ActiveData[curr.GUID]=curr.Status;
                    })
                }
            }
            setNewBusinessUnit(Object.entries(GlobalData)?.map(([key1, column]: any, index) =>    ({ key: key1, text: column ,label:column,value:column })))

            return    Object.entries(GlobalData)?.map(([key1, column]: any, index) =>    ({ key: key1, text: column,label:column,value:column,status:ActiveData[key1] }))

})
}

export  function GetAllCounterpartyType({
    setNewBusinessUnit=(_val)=>{},
    Refresh=false
}:IpropsGetAllBusinessUnitName)
{
return fetchertwemp(Refresh).then(c=>{
   const  GlobalData={};
            if (c.length > 0) {
                if (c[0].CounterpartyType != null) {
                    const counterpartytypeArray = JSON.parse(c[0]?.CounterpartyType);
                    counterpartytypeArray.map((curr, index) => {
                        GlobalData[curr.GUID]=curr.Name;
                    })
                }
            }
                setNewBusinessUnit({...GlobalData});
                return GlobalData
})
}

// export async function GetAllCounterpartyTypeOptions({
//     setNewBusinessUnit=(_val)=>{},
//     Refresh=false
// }:IpropsGetAllBusinessUnitName)
// {
// return fetchertwemp(Refresh).then(c=>{
//            const GlobalData1=[];
//             if (c.length > 0) {
//                 if (c[0].CounterpartyType != null) {
//                     const counterpartytypeArray = JSON.parse(c[0]?.CounterpartyType);
//                     counterpartytypeArray.map((curr, index) => {
//                         let f1={
//                             key: curr.GUID, text: curr.Name 
//                         }
//                         GlobalData1.push(f1) // GlobalData[curr.GUID]=curr.Name;
//                     })
//                 }
//             }
//            // setNewBusinessUnit(Object.entries(GlobalData)?.map(([key1, column]: any, index) =>    ({ key: key1, text: column })))
//            setNewBusinessUnit(GlobalData1) 
//         return  GlobalData1//  Object.entries(GlobalData)?.map(([key1, column]: any, index) =>    ({ key: key1, text: column  }))
// })
// }